/**
 * /me/* 端点的瘦封装。后端见 app/profile/routes.py。
 */

import { http } from '@/api/http'
import type { MeResponse } from '@/stores/auth'

export function getMe(): Promise<MeResponse> {
  return http.get<MeResponse>('/me')
}

export interface UpdateProfileRequest {
  display_name?: string
  avatar?:       string
}

export function updateProfile(req: UpdateProfileRequest): Promise<MeResponse> {
  return http.patch<MeResponse>('/me', req)
}

export interface ChangePasswordRequest {
  old_password: string
  new_password: string
}

/** 204 No Content. 返回 null。*/
export function changePassword(req: ChangePasswordRequest): Promise<null> {
  return http.post<null>('/me/password', req)
}
